import { type ScrollbarProps, Scrollbars } from "react-custom-scrollbars";

export default function Scrollbar(props: ScrollbarProps) {
  const { ...rest } = props;

  return <Scrollbars hideTracksWhenNotNeeded {...rest} />;
}
